<div class="modal-header">
  <h4 class="modal-title">{{ titulo }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <form
          action=""
          [formGroup]="categoryForm"
          (ngSubmit)="registerCategory()"
          class="form-horizontal form-material"
          id="categoryform"
          novalidate
        >
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="categoryForm.controls['nombre']"
                [controlName]="'Nombre De Categoría'"
              >
                <label for="nombre">Categoría</label>
                <input
                  class="form-control"
                  type="text"
                  id="nombre"
                  formControlName="nombre"
                  placeholder="Nombre de Categoría"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="categoryForm.controls['descripcion']"
                [controlName]="'Descripción.'"
              >
                <label for="descipcion">Descripción</label>
                <input
                  class="form-control"
                  type="text"
                  id="descipcion"
                  formControlName="descripcion"
                  placeholder="Nombre de la Descripción"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="categoryForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Guardar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
